import { createNotImplementedMethod } from '../utils';
var NotImplementedRedeemCouponRepository = /** @class */ (function () {
    function NotImplementedRedeemCouponRepository() {
        this.redeemCoupon = createNotImplementedMethod();
        this.redeemB2BCoupon = createNotImplementedMethod();
    }
    return NotImplementedRedeemCouponRepository;
}());
export { NotImplementedRedeemCouponRepository };
